import { AuthSideHeader } from '../../atoms';
import { AuthSideContent } from '../AuthSideContent';
import { Trans, useTranslation } from 'react-i18next';

export const RegisterSideContent = () => {
    const { t } = useTranslation();

    return (
        <AuthSideContent>
            <AuthSideHeader>{t('Pages.Auth.SideContent.Header')}</AuthSideHeader>
            <Trans i18nKey="Pages.Auth.SideContent.Text" />
        </AuthSideContent>
    );
};
